import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { RaceSummaryCaption } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/RaceSummary.style';
import { RaceTableCaption } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/greyhoundRacing/HeadersGreyhoundRacing.style';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { TableHeaderCell } from 'src/ui/components/table/sports/row/hr-gr/event/custom/TableHeaderCell';

interface HeadersPropsType {
    inAntePost: boolean;
    isPriceHistoryHidden: boolean;
    market: MarketModel;
    type?: string;
}

export const HeadersGreyhoundRacing = observer('HeadersGreyhoundRacing', (props: HeadersPropsType) => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { sportsbookVariant } = configState.componentVariants;
    const breakpointsState = BreakpointsState.get(common);
    const { type, market, inAntePost, isPriceHistoryHidden } = props;

    if (type === 'cast') {
        return (
            <RaceSummaryCaption variant={sportsbookVariant}>
                <TableHeaderCell
                    isWide={true}
                    dataTest='race-summary-header-runner'
                >
                    <I18n
                        langKey='events.race-summary.runner.label'
                        defaultText='Runner'
                    />
                </TableHeaderCell>

                <TableHeaderCell
                    align='center'
                    dataTest='race-summary-header-1st'
                    mobileSize='48px'
                    tabletSize='63px'
                >
                    <I18n
                        langKey='events.race-summary.1st.label'
                        defaultText='1st'
                    />
                </TableHeaderCell>

                <TableHeaderCell
                    align='center'
                    dataTest='race-summary-header-2nd'
                    mobileSize='48px'
                    tabletSize='63px'
                >
                    <I18n
                        langKey='events.race-summary.2nd.label'
                        defaultText='2nd'
                    />
                </TableHeaderCell>

                {market.tricastsOffered ? (
                    <TableHeaderCell
                        align='center'
                        dataTest='race-summary-header-3rd'
                        mobileSize='48px'
                        tabletSize='63px'
                    >
                        <I18n
                            langKey='events.race-summary.3rd.label'
                            defaultText='3rd'
                        />
                    </TableHeaderCell>
                ) : null}

                <TableHeaderCell
                    align='center'
                    dataTest='race-summary-header-anyorder'
                    mobileSize='48px'
                    tabletSize='63px'
                >
                    <I18n
                        langKey='events.race-summary.any-order.label'
                        defaultText='Any Order'
                    />
                </TableHeaderCell>
            </RaceSummaryCaption>
        );
    } else if (inAntePost) {
        return (
            <RaceTableCaption>
                <TableHeaderCell isWide={true}>
                    <I18n
                        langKey='events.race-summary.runner.label'
                        defaultText='Runner'
                    />
                </TableHeaderCell>

                <TableHeaderCell
                    align='center'
                    mobileSize='48px'
                    tabletSize='63px'
                >
                    <I18n
                        langKey='events.race-summary.price.label'
                        defaultText='Price'
                    />
                </TableHeaderCell>
            </RaceTableCaption>
        );
    } else {
        return (
            <RaceSummaryCaption variant={sportsbookVariant}>
                <TableHeaderCell isWide={true}>
                    <I18n
                        langKey='events.race-summary.runner.label'
                        defaultText='Runner'
                    />
                </TableHeaderCell>

                {isPriceHistoryHidden ? null : (
                    <TableHeaderCell
                        align='center'
                        mobileSize='64px'
                        tabletSize='96px'
                    >
                        <I18n
                            langKey='events.race-summary.history.label'
                            defaultText='History'
                        />
                    </TableHeaderCell>
                )}

                <TableHeaderCell
                    align='center'
                    mobileSize='48px'
                    tabletSize='63px'
                >
                    <I18n
                        langKey='events.race-summary.price.label'
                        defaultText='Price'
                    />
                </TableHeaderCell>

                {breakpointsState.tablet.isBiggerOrEq === true ? (
                    <TableHeaderCell
                        align='center'
                        mobileSize='48px'
                        tabletSize='63px'
                    >
                        SP
                    </TableHeaderCell>
                ) : null}
            </RaceSummaryCaption>
        );
    }
});
